import * as React from "react";
import {useSelector} from "react-redux";
import {css, Theme, useTheme} from "@emotion/react";

import {calculateRemSize, flex, pv} from "@pg-design/helpers-css";
import {ArrowIcon, ChevronLeftIcon, ChevronRightIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {IRPStore} from "../../../app/rp_reducer";
import {IPropertyListObj} from "../../../property_list/hooks/use_property_list";
import {DEFAULT_PROPERTY_LIST_MODAL_PAGE_SIZE} from "../../list/components/OfferListPropertiesModal";
import {hitOfferModalArrowGtm} from "../../tracking/offer_modal_arrow_gtm_events";

interface IProps {
    handleQuickViewClose: () => void;
    setSelectedIndex: (index: number) => void;
    propertyList: IPropertyListObj;
    selectedIndex: number;
    onNextClickEvent?: () => void;
    onPrevClickEvent?: () => void;
    headerTitle?: string;
}

export const QWHeaderWithPagination = (props: IProps) => {
    const {handleQuickViewClose, selectedIndex, setSelectedIndex, onNextClickEvent, onPrevClickEvent} = props;
    const {properties, pageCount, onPageChange, page} = props.propertyList;
    const totalPropertiesCount = useSelector((store: IRPStore) => store.offerDetail.properties.modal.count);
    const theme = useTheme();

    const countPropertyNumber = (index: number, page: number) => {
        return (page - 1) * DEFAULT_PROPERTY_LIST_MODAL_PAGE_SIZE + index + 1;
    };

    const currentPropertyNumber = countPropertyNumber(selectedIndex, page.currentPage);

    const handlePreviousClick = async () => {
        hitOfferModalArrowGtm("left", "property");
        onPrevClickEvent?.();

        if (selectedIndex === 0 && page.currentPage === 1) {
            if (pageCount === 1) {
                // if there is only one page we don't need to fetch property list
                setSelectedIndex(properties.length - 1);
            } else {
                const results = await onPageChange(pageCount);
                results && setSelectedIndex(results.length - 1);
            }
        } else if (selectedIndex === 0) {
            const results = await onPageChange(page.currentPage - 1);
            results && setSelectedIndex(results.length - 1);
        } else {
            setSelectedIndex(selectedIndex - 1);
        }
    };

    const handleNextClick = async () => {
        hitOfferModalArrowGtm("right", "property");
        onNextClickEvent?.();

        if (currentPropertyNumber === totalPropertiesCount) {
            if (pageCount === 1) {
                // if there is only one page we don't need to fetch property list
                setSelectedIndex(0);
                return;
            } else {
                await onPageChange(1);
                setSelectedIndex(0);
            }
        } else if (selectedIndex === properties.length - 1) {
            await onPageChange(page.currentPage + 1);
            setSelectedIndex(0);
        } else {
            setSelectedIndex(selectedIndex + 1);
        }
    };

    return (
        <div css={quickViewHeader}>
            <div onClick={handleQuickViewClose} css={backToListButton}>
                <ArrowIcon size="2" />
                <Text variant="button_medium" as="span">
                    {props.headerTitle ? `lista ${props.headerTitle}` : "Powrót do listy"}
                </Text>
            </div>

            <div css={paginationHolder}>
                {/*Don't show pagination buttons if there is only one property*/}
                {totalPropertiesCount !== 1 && (
                    <button onClick={handlePreviousClick}>
                        <ChevronLeftIcon size="1.5" wrapperColor={theme.colors.primary} wrapperSize="3.2" />
                    </button>
                )}

                <Text variant="body_copy_1" css={paginationCounter} align="center" strong>
                    {currentPropertyNumber}/{totalPropertiesCount}
                </Text>

                {/*Don't show pagination buttons if there is only one property*/}
                {totalPropertiesCount !== 1 && (
                    <button onClick={handleNextClick}>
                        <ChevronRightIcon size="1.5" wrapperColor={theme.colors.primary} wrapperSize="3.2" />
                    </button>
                )}
            </div>
        </div>
    );
};

const quickViewHeader = (theme: Theme) => css`
    display: flex;
    justify-content: space-between;
    ${pv(1.5)};

    @media (min-width: ${theme.breakpoints.md}) {
        padding: 1.6rem 1.9rem;
    }
`;

const backToListButton = css`
    cursor: pointer;
    align-items: center;
    display: flex;

    > span {
        font-size: 1.4rem;
        margin-left: 1rem;
    }

    &:hover {
        text-decoration: underline;
    }
`;

const paginationHolder = css`
    ${flex("center", "center")};
    gap: ${calculateRemSize(1.5)};
    margin-left: auto;
`;

const paginationCounter = css`
    ::selection {
        background: transparent;
    }
`;
import * as React from "react";
import {useSelector} from "react-redux";
import {css, Theme, useTheme} from "@emotion/react";

import {calculateRemSize, flex, pv} from "@pg-design/helpers-css";
import {ArrowIcon, ChevronLeftIcon, ChevronRightIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {IRPStore} from "../../../app/rp_reducer";
import {IPropertyListObj} from "../../../property_list/hooks/use_property_list";
import {DEFAULT_PROPERTY_LIST_MODAL_PAGE_SIZE} from "../../list/components/OfferListPropertiesModal";
import {hitOfferModalArrowGtm} from "../../tracking/offer_modal_arrow_gtm_events";

interface IProps {
    handleQuickViewClose: () => void;
    setSelectedIndex: (index: number) => void;
    propertyList: IPropertyListObj;
    selectedIndex: number;
    onNextClickEvent?: () => void;
    onPrevClickEvent?: () => void;
    headerTitle?: string;
}

export const QWHeaderWithPagination = (props: IProps) => {
    const {handleQuickViewClose, selectedIndex, setSelectedIndex, onNextClickEvent, onPrevClickEvent} = props;
    const {properties, pageCount, onPageChange, page} = props.propertyList;
    const totalPropertiesCount = useSelector((store: IRPStore) => store.offerDetail.properties.modal.count);
    const theme = useTheme();

    const countPropertyNumber = (index: number, page: number) => {
        return (page - 1) * DEFAULT_PROPERTY_LIST_MODAL_PAGE_SIZE + index + 1;
    };

    const currentPropertyNumber = countPropertyNumber(selectedIndex, page.currentPage);

    const handlePreviousClick = async () => {
        hitOfferModalArrowGtm("left", "property");
        onPrevClickEvent?.();

        if (selectedIndex === 0 && page.currentPage === 1) {
            if (pageCount === 1) {
                // if there is only one page we don't need to fetch property list
                setSelectedIndex(properties.length - 1);
            } else {
                const results = await onPageChange(pageCount);
                results && setSelectedIndex(results.length - 1);
            }
        } else if (selectedIndex === 0) {
            const results = await onPageChange(page.currentPage - 1);
            results && setSelectedIndex(results.length - 1);
        } else {
            setSelectedIndex(selectedIndex - 1);
        }
    };

    const handleNextClick = async () => {
        hitOfferModalArrowGtm("right", "property");
        onNextClickEvent?.();

        if (currentPropertyNumber === totalPropertiesCount) {
            if (pageCount === 1) {
                // if there is only one page we don't need to fetch property list
                setSelectedIndex(0);
                return;
            } else {
                await onPageChange(1);
                setSelectedIndex(0);
            }
        } else if (selectedIndex === properties.length - 1) {
            await onPageChange(page.currentPage + 1);
            setSelectedIndex(0);
        } else {
            setSelectedIndex(selectedIndex + 1);
        }
    };

    return (
        <div css={quickViewHeader}>
            <div onClick={handleQuickViewClose} css={backToListButton}>
                <ArrowIcon size="2" />
                <Text variant="button_medium" as="span">
                    {props.headerTitle ? `lista ${props.headerTitle}` : "Powrót do listy"}
                </Text>
            </div>

            <div css={paginationHolder}>
                {/*Don't show pagination buttons if there is only one property*/}
                {totalPropertiesCount !== 1 && (
                    <button onClick={handlePreviousClick}>
                        <ChevronLeftIcon size="1.5" wrapperColor={theme.colors.primary} wrapperSize="3.2" />
                    </button>
                )}

                <Text variant="body_copy_1" css={paginationCounter} align="center" strong>
                    {currentPropertyNumber}/{totalPropertiesCount}
                </Text>

                {/*Don't show pagination buttons if there is only one property*/}
                {totalPropertiesCount !== 1 && (
                    <button onClick={handleNextClick}>
                        <ChevronRightIcon size="1.5" wrapperColor={theme.colors.primary} wrapperSize="3.2" />
                    </button>
                )}
            </div>
        </div>
    );
};

const quickViewHeader = (theme: Theme) => css`
    display: flex;
    justify-content: space-between;
    ${pv(1.5)};

    @media (min-width: ${theme.breakpoints.md}) {
        padding: 1.6rem 1.9rem;
    }
`;

const backToListButton = css`
    cursor: pointer;
    align-items: center;
    display: flex;

    > span {
        font-size: 1.4rem;
        margin-left: 1rem;
    }

    &:hover {
        text-decoration: underline;
    }
`;

const paginationHolder = css`
    ${flex("center", "center")};
    gap: ${calculateRemSize(1.5)};
    margin-left: auto;
`;

const paginationCounter = css`
    ::selection {
        background: transparent;
    }
`;
